import axios from 'axios'

export const COPAY_FUNCTIONS_BASE = 'https://asia-east2-vr1game.cloudfunctions.net'

export function normalizeCopayVisibleCodes (value) {
  const values = Array.isArray(value) ? value : String(value || '').split(',')
  return values
    .map(code => String(code || '').trim().toUpperCase())
    .filter(Boolean)
}

export function isCopayDepositAvailableForCode (config, userCode) {
  if (!config || config.enabled !== true || config.depositEnabled !== true || config.availableNow === false) return false

  const codes = normalizeCopayVisibleCodes(config.visibleToCodes)
  const normalizedUserCode = String(userCode || '').trim().toUpperCase()
  return codes.includes('*') || Boolean(normalizedUserCode && codes.includes(normalizedUserCode))
}

export async function fetchCopayPublicConfig () {
  const response = await axios.get(`${COPAY_FUNCTIONS_BASE}/copayPublicConfig`, {
    timeout: 10000,
    params: { _: Date.now() }
  })
  const payload = response && response.data
  if (!payload || !payload.success || !payload.data) {
    throw new Error('Copay public config response ไม่ถูกต้อง')
  }
  return payload.data
}
